module.exports = __webpack_public_path__ + "img/icon1.882c8f04.png";